export default __webpack_public_path__ + "static/media/notification.2e0e1185.wav";